import logger from '@/services/logger';
import returnAppConfig from '@/helpers/return-app-config';



const baseRequest = {
  apiVersion: 2,
  apiVersionMinor: 0
};



const googlePay = {
  client: null,
  paymentGateway: null,

  async isSupported(options) {
    try {
      googlePay.paymentGateway = options.paymentGateway;
      let googlePayEnvironment = 'TEST';
      const config = googlePay.paymentGateway.methods.googlePay.googlePayConfig;

      if (returnAppConfig().isProductionEnvironment) {
        googlePayEnvironment = 'PRODUCTION';
      }

      if (options.environment) {
        googlePayEnvironment = options.environment;
      }

      googlePay.client = new window.google.payments.api.PaymentsClient({
        environment: googlePayEnvironment
      });

      let request;

      if (options.request) {
        request = options.request;
      }

      else {
        request = {
          ...baseRequest,
          allowedPaymentMethods: config.allowedPaymentMethods
        };
      }

      return await googlePay.client.isReadyToPay(JSON.parse(JSON.stringify(request)));
    }

    catch (error) {
      logger.error(error);

      return false;
    }
  },

  async requestPayment(options) {
    try {
      googlePay.paymentGateway = options.paymentGateway;
      let { request } = options;
      const config = googlePay.paymentGateway.methods.googlePay.googlePayConfig;

      if (!request) {
        const transactionInfo = {
          ...config.transactionInfo,
          totalPrice: options.total.toString(),
          totalPriceStatus: 'FINAL'
        };

        request = {
          ...baseRequest,
          ...config,
          transactionInfo
        };
      }

      const payment = await googlePay.client.loadPaymentData(JSON.parse(JSON.stringify(request)));

      return payment;
    }

    catch (error) {
      throw error;
    }
  }
};



export default googlePay;
